import React, {useState, useEffect, useRef }from 'react'
import {hostUrl, tokenExpiredLoginAgain, setSpinner, siteUrl, highTrafficInnerPages, invalidUsername, invalidPassword, highTrafficLogin, passwordWeak, passwordMedium, confirPasswordNotMatched } from '../../constants/global';
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import allActions from '../../actions/index';
import {useNavigate, NavLink  } from "react-router-dom";
import {shortNameUser, formatPostDate} from '../common/Helper';
import VerifyImg from '../../assets/images/Verify.svg';
import { callPageRenderTracking, scrollRunResources, LoadingSection, SingleLoadingSection } from '../common/Helper';

import AnchorLink from 'react-anchor-link-smooth-scroll-v2';

import { Editor } from '@tinymce/tinymce-react';

function TopicDetail() {

    // console.log("topic detail render");
    
    const editorRef = useRef(null);

    var { id } = useParams();

    //console.log(id);
    
    const dispatch = useDispatch();
    const navigate = useNavigate();

    /****Get Data from storage*****/
    const LoginLogoutData = useSelector(state => state.LoginLogout);
    const topicBucketState =  useSelector(state => state.TopicBucket);
    var topicBucketStateBucket = topicBucketState.bucket.owner_question;
    if(topicBucketStateBucket){
        var fromStorage = topicBucketStateBucket.find(obj => obj.ID === id);
    }


    /*****Define Constants*****/
    const [useripaddress, setUserIpAddress] =  useState("");
    const [isActive, setActive] = useState("false");
    const [question, setQuestion] = useState(fromStorage ? fromStorage : "");
    const [replies, setReplies] = useState("");
    const [replycontent, setReplyContent] = useState("Comment");
    const [responsemessage, setResponseMessage] = useState("");
    const [loading, setLoading] = useState(false);
    //var [id,setId] = useState("");
    var [topicid,setTopicId] = useState(id);

    console.log(id+' - '+topicid);
    //setTopicId(id);

    const AddClass = (e) => {
        var _target = e.target;
        var active_id = _target.getAttribute('data-id');
       setActive(active_id);
    };

    const RemoveClass = (e) => {
        var _target = e.target;
        var active_id = _target.getAttribute('data-id');
       setActive("false");
    };


    //console.log(objectFound);

    useEffect(() => {
        console.log("topic detail run effect");
        /****move to top***/
        window.scrollTo(0, 0);

        /******get data from localstorage*******/
        let authlogin = localStorage.getItem('authlogin');
        let storageData = authlogin ? JSON.parse(authlogin) : "";
        
        var token = 'Bearer '+storageData.token;
        var username = storageData.user_email;

        const data = { callingaction: 'topic_detail', topic_id: id };

        const requestOptions = {
                method: 'POST',
                //mode:'cors',
                headers: { 'Content-Type': 'application/json', 
                'POST' : '/resource HTTP/1.1',
                'Authorization': token,
                'Host' : hostUrl,
                'username' : username,
                body: JSON.stringify(data),
                }
            };

        fetch(siteUrl+'/community-rest-functions.php?action=topic_handle',requestOptions)
        .then((response) => response.json())
        .then(function(actualData){ 

            console.log(actualData);

            if(actualData.status==='success'){

                var post_title_render = actualData.topic_data.question[0].post_title;
                callPageRenderTracking({page_title:post_title_render,page_link:window.location.href});

                // console.log(actualData);
                // console.log("testestest");

            /******set question and replies*****/
            setQuestion(actualData.topic_data.question[0]);
            setReplies(actualData.topic_data.replies);   
            
            }else if(actualData.status==='validationerror'){
                dispatch( allActions.ModalPopup.showPopup({ popupname:'alertbox', title: tokenExpiredLoginAgain}));
                //alert(tokenExpiredLoginAgain);
                navigate('/login/?message='+tokenExpiredLoginAgain);
            }
        }).catch(rejected => {
            //setResponseMessage({status:"error",message:highTrafficInnerPages});
        });


        /*******add class on body*****/
        document.body.classList.add('white-bg-header', 'show-search-box');
        return () => {
            document.body.classList.remove('white-bg-header', 'show-search-box');
        }

    },[navigate]);


    /**** question data****/
    const QuestionData = (data) => {

        /******get data from localstorage*******/
        let authlogin = localStorage.getItem('authlogin');
        let storageDataAuthLogin = authlogin ? JSON.parse(authlogin) : "";

        var formatDate = formatPostDate(question.post_date);

        if(data.sectionflag==="onlyquestion"){
            return  <h1 className='topic-banner-title m-0'>{question.post_title}</h1>
        }

        if(data.sectionflag==="questionanswer"){
            return  <div className='comment-row'>
                        <div className='comment-header'>
                            <div className='post-list-info'>
                                <div className='info-col'><span className="material-icons-outlined">person</span> {question.post_anonymously === "1" ? "User"+question.post_author : question.author_name}</div>  
                                <div className="info-space">|</div>
                                <div className='info-col'><span className="material-icons-outlined"> calendar_month</span> {formatDate}</div>
                            </div>
                        </div>
                        {question.post_content && 
                        <div className='comment-box'>
                            <div className="content" dangerouslySetInnerHTML={{__html: question.post_content}}></div>
                        </div>
                        }
                    </div> 
            }

    }

    const likeAnswerHandler = (e) => {

        var replyid = e.target.getAttribute('replyid');

        /******disable like button for 3 seconds*****/
        e.target.disabled = true;
        setTimeout(() => {
        e.target.disabled = false
        }, 3 * 1000);


        /******get data from localstorage*******/
        let authlogin = localStorage.getItem('authlogin');
        let storageData = authlogin ? JSON.parse(authlogin) : "";
        
        var token = 'Bearer '+storageData.token;
        var username = storageData.user_email;

        var likeflag = e.target.checked ?? false;

        if(likeflag===true){
            var current_count = document.getElementsByClassName('count-likes-by-'+replyid)[0].innerHTML;
            var count_increase = Number(current_count)+1;
            document.getElementsByClassName('count-likes-by-'+replyid)[0].innerHTML = count_increase;
        }else{
            var current_count = document.getElementsByClassName('count-likes-by-'+replyid)[0].innerHTML;
            var count_increase = Number(current_count)-1;
            document.getElementsByClassName('count-likes-by-'+replyid)[0].innerHTML = count_increase;
        }

        const data = { callingaction: 'reply_like', replyid: replyid, flag : likeflag };

        const requestOptions = {
                method: 'POST',
                //mode:'cors',
                headers: { 'Content-Type': 'application/json', 
                'POST' : '/resource HTTP/1.1',
                'Authorization': token,
                'Host' : hostUrl,
                'username' : username,
                body: JSON.stringify(data),
                }
            };

        fetch(siteUrl+'/community-rest-functions.php?action=topic_handle',requestOptions)
        .then((response) => response.json())
        .then(function(actualData){ 

            if(actualData.status==='success'){

                
            
            }else if(actualData.status==='validationerror'){
                dispatch( allActions.ModalPopup.showPopup({ popupname:'alertbox', title: tokenExpiredLoginAgain}));
                //alert(tokenExpiredLoginAgain);
                navigate('/login/?message='+tokenExpiredLoginAgain);
            }
        }).catch(rejected => {
            //setResponseMessage({status:"error",message:highTrafficInnerPages});
        });
        
    }


    /******replies loop*****/
    const RepliesData = () => {

        return replies.map((element) => {

            var userID = LoginLogoutData.user.authid;
            
            var user_short_name = shortNameUser(element.author_name);

            /******get data from localstorage*******/
            let authlogin = localStorage.getItem('authlogin');
            let storageDataAuthLogin = authlogin ? JSON.parse(authlogin) : "";

            var formatDate = formatPostDate(element.post_date);

            var likedUsers  = element.liked;

            return <div className={isActive===element.ID ? "answers-box more" : "answers-box"} key={element.ID}>
                    
                    <div className="answers-info">
                        <div className='answers-info-image'>
                            {element.post_anonymously === "1" ? "U" : user_short_name}
                            {element.author_name=="CIIS Support" && <img className='verified-img' src={VerifyImg}/>}
                        </div>
                        <div className='answers-name'>{element.post_anonymously === "1" ? "User"+storageDataAuthLogin.authid : element.author_name}</div>  
                        <div className='post-list-info'><div className='info-col'><span className="material-icons-outlined"> calendar_month </span> {formatDate}</div></div>
                    </div>
                    <div className='answers-content'>
                        
                        <div className="content" dangerouslySetInnerHTML={{__html: element.post_content}}></div>

                        <span className="disclaimer">The responses are retrieved from CIIS summit sessions. Please exercise caution into directly referring them for investigative purposes.</span>
                    </div>
                    {element.post_content.length >= 200 && 
                        <>
                        <button type='button' data-id={element.ID} className='read-more' onClick={(e) => AddClass(e)}>Read More</button>
                        <button type='button' data-id={element.ID} className='read-less' onClick={(e) => RemoveClass(e)}>Read Less</button>
                        </>
                    }


                    <div className='answers-like-box'>
                        <ul>
                        <li>
                            <input id='like_input' className="like-btn" type="checkbox" defaultChecked={likedUsers.includes(userID)==true && 'checked'}  replyid={element.ID} onClick={(e) => likeAnswerHandler(e)}/>
                            <label className='like-checkbox' htmlFor='like_input'>
                            <span className='material-icons-outlined'>thumb_up</span> Like (<span className={'count-likes count-likes-by-'+element.ID}>{likedUsers.length}</span>) </label>

                        </li>
                        </ul>
                    </div>

                </div>
          
            }
        )
    }

    /**********Submit Reply***********/
    const submitReply  = (e) => {
        e.preventDefault();

        var topicreplycontent = editorRef.current.getContent();

        if(topicreplycontent){

            /*******get the user ip address*********/
            //https://geolocation-db.com/json/d802faa0-10bd-11ec-b2fe-47a0872c6708
            fetch('https://ipwho.is/').then(response => {
            return response.json();
            }).then((res) => {
                if(res.IPv4){
                    setUserIpAddress(res.IPv4);
                }            
            });

        
            var topic_title = question.post_title;
            /******get data from localstorage*******/
            let authlogin = localStorage.getItem('authlogin');
            let storageData = authlogin ? JSON.parse(authlogin) : "";
            
            var token = 'Bearer '+storageData.token;
            var username = storageData.user_email;

            setLoading(true);

            const data = { callingaction: 'topic_reply', topic_title: topic_title, topic_id: id, content : topicreplycontent, userip: useripaddress  };

            const requestOptions = {
                    method: 'POST',
                    //mode:'cors',
                    headers: { 'Content-Type': 'application/json', 
                    'POST' : '/resource HTTP/1.1',
                    'Authorization': token,
                    'Host' : hostUrl,
                    'username' : username,
                    body: JSON.stringify(data),
                    }
                };

            fetch(siteUrl+'/community-rest-functions.php?action=topic_handle',requestOptions)
            .then((response) => response.json())
            .then(function(actualData){ 
                
                setResponseMessage({status:"success",message:"Your comment has been shared with the moderator"});
                setReplyContent("");
                setLoading(false);

            
            }).catch(rejected => {
                //setResponseMessage({status:"error",message:highTrafficInnerPages});
            });
        }


    }

    /*********set on state accroding to fields************/
    const handleInputChange = (replycontent) => {
        // if(e.target.name==="reply-content"){
        //     setReplyContent(e.target.value);
        // }
    }

    // console.log(replies.length);
    // console.log("replies length");

  return (
    <>
    <div className="fullpage-box knowledge-fullpage-box topic-content-box p-l-0 p-r-0">

    {/*********Question Section only*********/} 
        <div className='topic-banner topic-detail-banner'>
                <div className="topic-container">

                <NavLink className="back-btn" to="/queries"><span className="material-icons-outlined">arrow_back </span>Back to Queries</NavLink>

                {question && <> 
                    {/*********back to topic**********/}
                    <QuestionData sectionflag="onlyquestion"/> 
                    </> 
                }
                </div>
        </div>
   
    {/******Container Section*******/}
    <div className="topic-container topic-detail-container">

    {question === "" && <LoadingSection />}

    {question && <>
        

        {/*********Question Content*********/}
        <QuestionData sectionflag="questionanswer"/>
        
        {/*********Replies*********/}
        <div className="answers-row">
            <div className='answers-title'>
                {replies.length} Answers 
                <AnchorLink href='#comment_form' className='add-comment'><span className="material-icons-outlined">add</span> Add Comment</AnchorLink>
            </div>

            {replies ? <RepliesData /> : <LoadingSection />}
        </div>

        {/*********Comment Form*********/}
        <div className='comment-form' id='comment_form'>
            
            <form onSubmit={submitReply}>

                <div className="comment-field">

                    { <Editor
                    apiKey="r5ixlsvtvg9v4rx95avemaeyvniv0ujxz8na67bi6kydcsx0"
                    onInit={(evt, editor) => editorRef.current = editor}
                    initialValue={replycontent}
                    init={{
                        height: 400,
                        menubar: false,
                        branding: false,
                        toolbar: 'undo redo | formatselect | ' +
                        'bold italic | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat',
                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                      }}
                       /> ?? <SingleLoadingSection/>}

                </div>

                {/****Response****/}
                {responsemessage && <span className="response-message">{responsemessage.message}</span>}
                
                <button type="submit" className="submit-reply">{loading && <span className="material-icons-outlined spin">motion_photos_on</span>}Submit</button>
            




            </form>
        </div>

    </>}

</div>
</div>

    </>
  )
}

export default TopicDetail